import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
export default {
  name: "friends",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin"])
  },
  data() {
    return {
      friendList: null,
      isLoading: false
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.isLoading = true;
          const friendInfo = await this.geteRankingFriend();
          console.log("friendInfo", friendInfo);
          if (!friendInfo) {
            this.isLoading = false;
            return;
          }
          this.isLoading = true;
          this.friendList = friendInfo;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["geteRankingFriend"]),
    onShare() {
      this.shareFn();
    },
    onCopy() {
      this.shareFn('copy');
    }
  }
};